import React from "react";
import Breadcrumbs from "../../../components/Breadcrumbs";
import RolesTable from "./RolesTable";
import Header from "../../layout/Header";
import Sidebar from "../../layout/Sidebar";

const Roles = () => {
  return (
    <div className="main-wrapper">
      <Header />
      <Sidebar />
      <div className="page-wrapper">
        <div className="content container-fluid">
          <Breadcrumbs
            maintitle="Roles "
            title="Dashboard"
            subtitle="Roles"
          />
          <RolesTable />
        </div>
      </div>
    </div>
  );
};

export default Roles;
